<template>
    <ion-header>
        <div class="rainbow-bar"></div>
        <ion-toolbar no-border color="dark">
            <ion-buttons slot="start">
                <ion-menu-toggle>
                    <ion-button class="menu-button">
                        <img class="icon-img" slot="icon-only" src="@/assets/icon-images/menu.png" />
                        <p v-if="notificationsCount" class="unread-count ion-float-end">
                            {{ notificationsCount }}
                        </p>
                    </ion-button>
                </ion-menu-toggle>
            </ion-buttons>
            <img class="logo" src="@/assets/logo-full.png" />
        </ion-toolbar>
    </ion-header>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'NavBar',
    data: () => {
        return {
            title: 'dating app',
            notificationsCount: 0
        }
    },
    computed: mapGetters(['getMessagesCount', 'getNotificationsCount']),
    watch: {
        getMessagesCount() {
            this.notificationsCount = this.getMessagesCount + this.getNotificationsCount
        },
        getNotificationsCount() {
            this.notificationsCount = this.getMessagesCount + this.getNotificationsCount
        }
    }
}
</script>

<style lang="scss" scoped>
.logo {
    position: relative;
    left: -25px;
    width: 150px;
}

#app[dir='rtl'] .logo {
    position: relative;
    right: -21px;
}

.rainbow-bar {
    display: inline-block;
    position: absolute;
    z-index: 1000000;
    width: 100%;
    bottom: 0;
    left: 0px;
    background: rgba(221, 212, 191, 1);
    background: -moz-linear-gradient(
        left,
        rgba(221, 212, 191, 1) 0%,
        rgba(221, 212, 191, 1) 20%,
        rgba(180, 199, 174, 1) 20%,
        rgba(180, 199, 174, 1) 40%,
        rgba(124, 193, 139, 1) 40%,
        rgba(124, 193, 139, 1) 60%,
        rgba(24, 134, 101, 1) 60%,
        rgba(24, 134, 101, 1) 80%,
        rgba(16, 69, 87, 1) 80%,
        rgba(16, 69, 87, 1) 100%
    );

    background: -webkit-linear-gradient(
        left,
        rgba(221, 212, 191, 1) 0%,
        rgba(221, 212, 191, 1) 20%,
        rgba(180, 199, 174, 1) 20%,
        rgba(180, 199, 174, 1) 40%,
        rgba(124, 193, 139, 1) 40%,
        rgba(124, 193, 139, 1) 60%,
        rgba(24, 134, 101, 1) 60%,
        rgba(24, 134, 101, 1) 80%,
        rgba(16, 69, 87, 1) 80%,
        rgba(16, 69, 87, 1) 100%
    );
    background: -o-linear-gradient(
        left,
        rgba(221, 212, 191, 1) 0%,
        rgba(221, 212, 191, 1) 20%,
        rgba(180, 199, 174, 1) 20%,
        rgba(180, 199, 174, 1) 40%,
        rgba(124, 193, 139, 1) 40%,
        rgba(124, 193, 139, 1) 60%,
        rgba(24, 134, 101, 1) 60%,
        rgba(24, 134, 101, 1) 80%,
        rgba(16, 69, 87, 1) 80%,
        rgba(16, 69, 87, 1) 100%
    );
    background: -ms-linear-gradient(
        left,
        rgba(221, 212, 191, 1) 0%,
        rgba(221, 212, 191, 1) 20%,
        rgba(180, 199, 174, 1) 20%,
        rgba(180, 199, 174, 1) 40%,
        rgba(124, 193, 139, 1) 40%,
        rgba(124, 193, 139, 1) 60%,
        rgba(24, 134, 101, 1) 60%,
        rgba(24, 134, 101, 1) 80%,
        rgba(16, 69, 87, 1) 80%,
        rgba(16, 69, 87, 1) 100%
    );
    background: linear-gradient(
        to right,
        rgba(221, 212, 191, 1) 0%,
        rgba(221, 212, 191, 1) 20%,
        rgba(180, 199, 174, 1) 20%,
        rgba(180, 199, 174, 1) 40%,
        rgba(124, 193, 139, 1) 40%,
        rgba(124, 193, 139, 1) 60%,
        rgba(24, 134, 101, 1) 60%,
        rgba(24, 134, 101, 1) 80%,
        rgba(16, 69, 87, 1) 80%,
        rgba(16, 69, 87, 1) 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ddd4bf', endColorstr='#104557', GradientType=1 );
    height: 5px;
}

.menu-button {
    position: relative;

    .unread-count {
        position: absolute;
        background: #ff0000;
        color: #ffffff !important;
        font-weight: 700;
        text-align: center;
        font-size: 12px;
        border-radius: 50%;
        width: 12px;
        height: 12px;
        left: 3px;
        top: 7px;
    }
}
</style>
